export default __webpack_public_path__ + "static/media/two-eyes.57f84d99.md";